// FAR-83 #13: the column widths the Capacity and Risk card and the SKU Plan
// share, so their month columns line up. Pure, so it is tested without a
// browser. Widths are border-box (CssBaseline): padding and borders are inside.

// Frozen columns: checkbox, Item, Brite, Line, DOS, Rate/hr.
export const LEFT_W = [40, 280, 70, 84, 104, 70]
// Each month has SUB_COUNT sub-columns (DEMAND, UNITS, INVENTORY, DOS).
export const COL_W = 74
export const SUB_COUNT = 4

// The frozen columns' widths. Months 4–18 has no Line or Rate/hr column.
export function frozenWidths(withLines) {
  return withLines ? [...LEFT_W] : [LEFT_W[0], LEFT_W[1], LEFT_W[2], LEFT_W[4]]
}

export function frozenWidth(withLines) {
  return frozenWidths(withLines).reduce((a, b) => a + b, 0)
}

// One month's width. Its 2px left border is inside it.
export function monthWidth() {
  return SUB_COUNT * COL_W
}

export function tableWidth(withLines, monthCount) {
  return frozenWidth(withLines) + (monthCount || 0) * monthWidth()
}
